/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { StreamableFeature } from "./types";

export default function Streamable(feature: StreamableFeature) {
  let toggleAction = feature.actions.set_value;

  this.toggleStreaming = () => {
    let newValue = !this.isStreaming();
    if (toggleAction == null) {
      return $.Deferred.reject(
        new Error(
          "Attempted to toggle streaming on a device whose streamable feature had no set_value action"
        )
      );
    } else {
      return this.executeDeviceAction(toggleAction, { value: newValue });
    }
  };

  this.isStreaming = () => feature.value;

  this.isConnected = () => feature.connected;

  return {
    status: feature.connected ? "Connected" : "Disconnected",
    streamWebUrl: feature.stream_web_url,
    streamAppUrl: feature.stream_app_url,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/streamable.js